module.exports = __webpack_public_path__ + "img/dependencies.6f50e2c1.svg";